import { FieldErrors, UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormScreenHeader } from './';
import { InputField } from '@web/utils/src';
import { IFormInput } from '../types';

interface PhoneScreenProps {
  register: UseFormRegister<IFormInput>;
  errors: FieldErrors<IFormInput>;
  setValue: UseFormSetValue<IFormInput>;
  formValues: IFormInput;
  handleStageChange: (e: any, direction: 'next' | 'previous') => void;
}

const PhoneScreen: React.FC<PhoneScreenProps> = ({
  register,
  errors,
  setValue,
  formValues,
  handleStageChange,
}) => {
  const { t } = useTranslation();

  return (
    <div role="phones-screen">
      <FormScreenHeader
        title={t('create_user_modal.add_your_phone_number')}
        handleStageChange={handleStageChange}
      />
      <div className="mt-2-0 grid grid-cols-1 gap-2-0">
        <InputField
          register={register}
          errors={errors}
          name="phoneNumber"
          setValue={setValue}
          t={t}
        />
      </div>
    </div>
  );
};

export default PhoneScreen;
